<template>
    <el-dialog title="关联撤销事件" :visible.sync="visible" @close="close" :close-on-click-modal="false" width="70vw">
        <el-row class="bottom20">
            <el-table ref="incidentRelationTableRef" :data="tableData"
                      highlight-current-row
                      @current-change="handleCurrentRowChange"
                      v-loading="loading">
                <el-table-column width="55">
                    <template slot-scope="scope">
                        <el-radio class="label-hidden" :value="selectedTicketId == null ? null : selectedTicketId" :label="scope.row.ticketid"></el-radio>
                    </template>
                </el-table-column>
                <el-table-column prop="actualstart" label="开始时间" min-width="180">
                    <template slot="header" slot-scope="scope">
                        开始时间<br>
                        <el-date-picker v-model="searchParams.startTime" placeholder="开始时间从"
                        size="small"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        class="custom-date-picker"
                        style="width: 136px;"
                    />
                        ~
                    <el-date-picker
                        v-model="searchParams.endTime"
                        placeholder="到"
                        size="small"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        class="custom-date-picker"
                        style="width: 136px;"/>
                    </template>
                </el-table-column>
                <el-table-column prop="source" label="事件来源" min-width="130">
                    <template slot="header" slot-scope="scope">
                        事件来源<br>
                        <dictionary-select v-model="searchParams.source"
                                           :factory-name="'domain'"
                                           :params="'TICKETSOURCE'"
                                           size="small"
                                           clearable>
                        </dictionary-select>
                    </template>
                    <template slot-scope="scope">
                        <dictionary-text :factory-name="'domain'"
                                         :params="'TICKETSOURCE'"
                                         :value="scope.row.source">
                        </dictionary-text>
                    </template>
                </el-table-column>
                <el-table-column prop="ticketid" label="事件编号" min-width="180">
                    <template slot="header" slot-scope="scope">
                        事件编号<br>
                        <el-input size="mini" class="width70"
                                  v-model="searchParams.ticketid"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="description" min-width="200" label="事件主题">
                    <template slot="header" slot-scope="scope">
                        事件主题<br>
                        <el-input size="mini" class="width70"
                                  v-model="searchParams.description"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="level" label="事件状态" min-width="130">
                    <template slot="header" slot-scope="scope">
                        事件状态<br>
                        <dictionary-select v-model="searchParams.status"
                                           :factory-name="'domain'"
                                           :params="'INCIDENTSTATUS2'"
                                           size="small"
                                           clearable
                                           multiple
                                           filterable
                                           collapse-tags>
                        </dictionary-select>
                    </template>
                    <template slot-scope="scope">
                        <dictionary-text :factory-name="'domain'"
                                         :params="'INCIDENTSTATUS2'"
                                         :value="scope.row.status">
                        </dictionary-text>
                    </template>
                </el-table-column>
                <el-table-column prop="level" label="事件等级" min-width="130">
                    <template slot="header" slot-scope="scope">
                        事件等级<br>
                        <dictionary-select v-model="searchParams.level"
                                           :factory-name="'domain'"
                                           :params="'TICKETLEVEL'"
                                           size="small"
                                           clearable>
                        </dictionary-select>
                    </template>
                    <template slot-scope="scope">
                        <dictionary-text :factory-name="'domain'"
                                         :params="'TICKETLEVEL'"
                                         :value="scope.row.level">
                        </dictionary-text>
                    </template>
                </el-table-column>
                <el-table-column prop="enterby" label="录入人员" min-width="130">
                    <template slot="header" slot-scope="scope">
                        录入人员<br>
                        <el-input size="mini" class="width70"
                                  v-model="searchParams.enterby">
                        </el-input>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>

        <el-row type="flex" class="row-bg" justify="end">
            <el-pagination align="right" @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="currentPage"
                           :page-sizes="pageSizes" :page-size="pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </el-row>

        <br>

        <el-row style="text-align: right">
            <el-button center="true" type="primary" @click="btnConfirmHandler">确定</el-button>
            <el-button center @click="close">关闭</el-button>
        </el-row>
    </el-dialog>
</template>

<script>

    import TicketServer from "@/api/ticket";
    import DictionarySelect from '@/components/common/DictionarySelect'
    import DictionaryText from '@/components/common/DictionaryText'
    import {formatDate} from "element-ui/src/utils/date-util";
    import RelationServer from "@/api/relation/relation";

    export default {
        name: "batchCancelDialog",

        components: {
            DictionarySelect,
            DictionaryText
        },

        props: {
            visible: {
                type: Boolean,
            },
            searchParams: {
                type: Object,
            },
            selectedCancelTicketIdArr: {
                type: Array,
            },
        },

        data() {
            return {
                tableData: [],

                currentPage: 1,
                pageSize: 10,
                pageSizes: [10, 25, 50, 100],
                total: 0,

                selectedTicketId: '',

                loading: false,
            }
        },

        methods: {
            close() {
                this.selectedTicketId = '';
                this.selectedCancelTicketIdArr = [];
                this.$emit('update:visible', false);
            },

            handleSizeChange(val) {
                this.pageSize = val;
                this.queryTable();
            },

            handleCurrentChange(val) {
                this.currentPage = val;
                this.queryTable();
            },

            queryTable() {
                let searchParamsNew = JSON.parse(JSON.stringify(this.searchParams));
                let statusStr = '';
                if(searchParamsNew.status != null){
                    for (let i = 0; i < searchParamsNew.status.length; i++) {
                        statusStr += searchParamsNew.status[i] + ',';
                    }
                    searchParamsNew.status = statusStr;
                }
                // searchParamsNew.dcnum = ''; //不进行数据中心的限制

                let params = {
                    'iDisplayStart': this.currentPage,
                    'iDisplayLength': this.pageSize,
                    'conditions': JSON.stringify(searchParamsNew),
                    'appId': 'WEB',
                    'token': localStorage.getItem("token")
                };
                TicketServer.ticket.page(params).then(res => {
                    if (res.data.code == 200) {
                        this.tableData = res.data.aaData;
                        this.total = res.data.iTotalRecords;
                    }
                });
            },

            handleCurrentRowChange(row) {
                this.selectedTicketId = row.ticketid;
            },

            btnConfirmHandler() {
                if (this.selectedTicketId == '') {
                    this.$message.error('请选择需要撤销关联的事件!');
                    return;
                }
                if (this.selectedCancelTicketIdArr.indexOf(this.selectedTicketId) > -1) {
                    this.$message.error('关联撤销事件不能关联自身!');
                    return;
                }
                let params = {
                    'ticketId': this.selectedTicketId,
                    'ticketIdArray': this.selectedCancelTicketIdArr,
                };
                if (this.selectedCancelTicketIdArr.length > 100) {
                    this.$message.info('您一次批量撤单数量过多，后台正进行处理，请您稍等');
                }

                this.loading = true;

                TicketServer.ticket.batchKillOrder(params).then(res => {
                    if (res.data.code == 200) {
                        this.relationArray = [];
                        for (let i = 0; i < this.selectedCancelTicketIdArr.length; i++) {
                            this.relationArray.push({
                                'clazz': 'INCIDENT',
                                'enterby': localStorage.getItem('username'),
                                'enterdate': formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                                'orgid': localStorage.getItem('authorg'),
                                'siteid': localStorage.getItem('defsite'),
                                'recordkey': this.selectedTicketId,
                                'relatedrecclass': 'INCIDENT',
                                'relatedreckey': this.selectedCancelTicketIdArr[i],
                                'relatedrecorgid': localStorage.getItem('authorg'),
                                'relatedrecsiteid': localStorage.getItem('defsite'),
                                'relatetype': 'RELATED',
                                'validation': 'VALID',
                            });
                            this.relationArray.push({
                                'clazz': 'INCIDENT',
                                'enterby': localStorage.getItem('username'),
                                'enterdate': formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                                'orgid': localStorage.getItem('authorg'),
                                'siteid': localStorage.getItem('defsite'),
                                'recordkey': this.selectedCancelTicketIdArr[i],
                                'relatedrecclass': 'INCIDENT',
                                'relatedreckey': this.selectedTicketId,
                                'relatedrecorgid': localStorage.getItem('authorg'),
                                'relatedrecsiteid': localStorage.getItem('defsite'),
                                'relatetype': 'RELATED',
                                'validation': 'VALID',
                            });
                        }
                        RelationServer.batchRelation(this.relationArray).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success("撤销关联成功");
                                this.$emit('loadedEventInfos', null);
                                this.close();
                            }
                        });
                        this.loading = false;
                    }
                });
            },
        },

        watch: {
            searchParams: {
                deep: true,
                handler: function (newVal, oldVal) {
                    this.queryTable();
                }
            }
        },
    }
</script>

<style scoped>

</style>
